import { render, staticRenderFns } from "./Collapsible.component.vue?vue&type=template&id=7d737673&scoped=true"
import script from "./Collapsible.component.vue?vue&type=script&lang=js"
export * from "./Collapsible.component.vue?vue&type=script&lang=js"
import style0 from "./Collapsible.component.vue?vue&type=style&index=0&id=7d737673&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d737673",
  null
  
)

export default component.exports